import formModel            from 'formModel';
import viewManager          from 'ViewManagerService';
import listService          from 'ListService';
import userService          from 'UserService';

class FormUnloadService {

    unloadForm() {
        try {
            formModel.initialize();

            if (listService.currentForm) {
                listService.currentForm.remove();
                listService.currentForm = undefined;
            }
            viewManager.deafenMains();

            listService._objMap.map( (v,k) => {
               v.close();
               //v.remove();
               v.$el.empty();
            });

            listService._pageList.map( (v,k) => {
                console.log("Page remove()")
               v.unbind();
               v.remove();
               v.$el.empty();
            });

            viewManager.clearPropertyViews();
            viewManager.clearToolbarPaneView();
            viewManager.clearMenuView();
            viewManager.clearEditorView();
            viewManager.clearBreadcrumbView();
            viewManager.clearPageView();
            viewManager.clearFormView();

            clearInterval(listService.recoverySaveInterval);
            userService.stopCheckingUserSession();
            
            listService.reset();

            console.log(listService);
        } catch (e) {
            console.log(e);
        }
    }

}

const formUnloadService = new FormUnloadService();
export default formUnloadService;